import { LocaleMessages } from "./ur-PK/messages";

export function flattenMessages(
    list: LocaleMessages,
    prefix: string = ""
): Record<string, string> {
    const messages: Record<string, string> = {};
    for (const [key, value] of Object.entries(list)) {
        const k = prefix.length > 0 ? `${prefix}.${key}` : key;

        if (typeof value === "string") {
            messages[k] = value;
        } else {
            Object.assign(messages, flattenMessages(value, k));
        }
    }

    return messages;
}
